import React from 'react'
import { Redirect, useParams } from 'react-router-dom'
import AccountLayout from '../../components/AccountLayout'
import { SEO } from '../../components/Seo/seo'
import { useIntl } from 'react-intl'
import { NamedRoutes } from '../../routes'
import { formatRoute } from 'react-router-named-routes'
import { InvoiceViewConsumer, InvoiceViewProvider } from '../../context/InvoiceViewContext'
import { LanguageConsumer } from '../../context/LanguageContext'
import SingleInvoicePageContent from '../../components/SingleInvoicePageContent'
import Configuration from '../../Services/Api/Configuration'
import UnAuthorize from '../../components/UnAuthorize'

const SingleInvoice = ({ isMs }) => {
  const intl = useIntl()
  let { id } = useParams()

  return (
    !!id ? <>
        <SEO title={intl.formatMessage({ id: 'Page.invoice.title' }, { uuid: id })}
             pathname={window.location.origin + formatRoute(NamedRoutes.singleInvoice, { id: id })}
             titleTemplate={intl.formatMessage({ id: 'eInvoice' })}
             description={intl.formatMessage({ id: 'Page.invoice.title' }, { uuid: id })}
        />

        <AccountLayout permission={Configuration.permissions.invoice.view} content={
          <LanguageConsumer>
            {({ locale }) => (
              <InvoiceViewProvider isMs={isMs} id={id} locale={locale}>
                <InvoiceViewConsumer>
                  {({ isUnauthorized }) => (
                        !!isUnauthorized ? <UnAuthorize/> :
                      <SingleInvoicePageContent isMs={isMs} locale={locale}/>
                  )}
                </InvoiceViewConsumer>
              </InvoiceViewProvider>
            )}
          </LanguageConsumer>
        }/>
      </>
      :
      <Redirect to={NamedRoutes.invoices}/>
  )
}

export default SingleInvoice
